import PubSub from 'pubsub-js';
import { QueryClient } from 'react-query';

import { addBreadcrumb } from 'config/sentryConfig';
import { AppEvent } from 'types/AppEvent';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: error => {
        try {
          addBreadcrumb({
            category: 'react-query',
            level: 'error',
            message: 'mutation error',
            data: { error: error instanceof Error ? error.message : String(error) },
          });
        } catch {
          // Breadcrumbs must never block mutation error handling.
        }
        PubSub.publish(AppEvent.API_MUTATION_ERROR, { error });
      },
    },
    queries: {
      onError: error => {
        try {
          addBreadcrumb({
            category: 'react-query',
            level: 'warning',
            message: 'query error',
            data: { error: error instanceof Error ? error.message : String(error) },
          });
        } catch {
          // Breadcrumbs must never block query error handling.
        }
        PubSub.publish(AppEvent.API_FETCH_ERROR, { error });
      },
    },
  },
});

export default queryClient;
